export default __webpack_public_path__ + "static/media/azvo.ec52553d.png";